import React from 'react';
import ConfettiExplosion from 'react-confetti-explosion';
import { Box, useTheme } from '@mui/material';

export const GamificationConfetti = ({ trigger }) => {
  const theme = useTheme();
  
  // Harmonized confetti colors based on theme
  const confettiColors = [
    theme.palette.gamification.primary,
    theme.palette.gamification.secondary,
    theme.palette.gamification.light,
    theme.palette.gamification.gold,
    theme.palette.gamification.coins,
    theme.palette.gamification.success,
    theme.palette.gamification.warning,
    '#FFD700', // Keep some gold for celebration
  ];

  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: 2000 }}>
      {trigger && (
        <ConfettiExplosion
          particleCount={120}
          width={window.innerWidth}
          duration={3500}
          force={0.8}
          colors={confettiColors}
        />
      )}
    </Box>
  );
};
